module.exports = __webpack_public_path__ + "static/media/right-menu-profile-icon.4d161509.svg";